<template>
    <el-dialog
        :before-close="handleClose"
        :visible.sync="dialogVisible"
        center
        class="dialog-container"
        width="600px">
        <div slot="title" class="title" v-if="type">
            {{ id ? '预警信息' : '添加预警信息' }}
        </div>
        <div slot="title" class="title" v-else>
            佐证材料
        </div>
        <div class="form-content padding-lr">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="ruleForm" label-width="130px">
                <template v-if="type">
                    <el-form-item label="教培机构名称" prop="org_id">
                        <el-select v-model="ruleForm.org_id" :disabled="readonly"
                                   class="inp" filterable placeholder="请选择">
                            <el-option v-for="item in orgList" :key="item.id"
                                       :label="item.org_name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="预警状态"
                                  prop="level">
                        <el-select v-model="ruleForm.level" class="inp" placeholder="请选择"  :disabled="readonly">
                            <el-option v-for="item in riskLevelOptions"
                                       :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="预警提示"
                                  prop="info">
                        <el-input v-model="ruleForm.info"
                                  class="inp"
                                  placeholder="请输入"  :disabled="readonly"></el-input>
                    </el-form-item>
                    <el-form-item label="预警描述"
                                  prop="information">
                        <el-input v-model="ruleForm.information"
                                  :autosize="{ minRows: 5, maxRows: 5 }"
                                  class="inp"
                                  placeholder="请输入"
                                  resize="none"
                                  type="textarea"  :disabled="readonly"></el-input>
                    </el-form-item>
                    <!--                <el-form-item label="预警时间"-->
                    <!--                              prop="zhenggai_time">-->
                    <!--                    <el-date-picker-->
                    <!--                        v-model="ruleForm.zhenggai_time"-->
                    <!--                        placeholder="选择日期"-->
                    <!--                        style="width: 100%;"-->
                    <!--                        type="date"-->
                    <!--                        value-format="yyyy-MM-dd">-->
                    <!--                    </el-date-picker>-->
                    <!--                </el-form-item>-->
                    <el-form-item label="处理状态"
                                  prop="status" v-if="readonly">
                        <el-select v-model="ruleForm.status" class="inp" placeholder="请选择"  :disabled="readonly">
                            <el-option v-for="item in riskStatusOptions2"
                                       :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="预警状态"
                                  prop="is_queren" v-else>
                        <el-select v-model="ruleForm.is_queren" class="inp" placeholder="请选择"  :disabled="readonly">
                            <el-option v-for="item in riskStatusOptions"
                                       :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </template>
                <el-form-item ref="chengnuoshu" class="" label="承诺书"
                              prop="chengnuoshu" v-if="ruleForm.chengnuoshu">
                    <div class="flex justify-start align-center">
                        <a v-if="ruleForm.chengnuoshu"
                           :href="ruleForm.chengnuoshu"
                           class="look" target="_blank">下载承诺书</a>
                    </div>
                </el-form-item>
                <el-form-item ref="cailiao" class="" label="证明文件"
                              prop="cailiao">
                    <div class="flex justify-start align-center">
                        <a v-if="ruleForm.cailiao"
                           :href="ruleForm.cailiao"
                           class="look" target="_blank">查看证明文件</a>
                        <upload-file
                            name="cailiao"
                            @uploadFile="uploadFile"
                            :disabled="readonly">
                            <div slot="upload" class="btnUp">
                                <i class="iconfont icon-iconfontzhizuobiaozhun0263"></i> 上传证明文件
                            </div>
                        </upload-file>
                    </div>
                </el-form-item>
            </el-form>
            <div class="btn-box" v-if="readonly">
                <div class="btn cancel" @click="handleClose">取消</div>
            </div>
            <div class="btn-box" v-else>
                <div class="btn" @click="submitForm('ruleForm')">{{ id ? '保存' : '确认添加' }}</div>
                <div class="btn cancel" @click="handleClose">取消操作</div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import UploadFile from "@/components/UploadFile";
import {scrollIntoView} from "@/utils/utils";
import {addWarning, getWarningDetail, org_lst} from "@/api/admin";
import {riskLevelOptions, riskStatusOptions2} from "@/utils/const";

export default {
    name: "addRiskDialog",
    data() {
        return {
            orgList:[],
            riskLevelOptions:riskLevelOptions,
            riskStatusOptions2:riskStatusOptions2,
            riskStatusOptions:[
                { value: 1,  label: '提示' },
                { value: 2, label: '预警'  }
            ],
            ruleForm: {
                org_id: '',
                level: '',//0灰色1黄色2橘色3红色
                info: '',//预警提示（
                information: '',//预警描述
                status: '',//处理状态
                cailiao: '',//证明文件
                is_queren: '',//预警状态 1提示2预警
                chengnuoshu:''
            },
            rules: {
                org_id: [
                    {required: true, message: '请选择机构', trigger: 'blur'}
                ],
                level: [
                    {required: true, message: '请选择预警状态', trigger: 'blur'}
                ],
                info: [
                    {required: true, message: '请输入预警提示', trigger: 'blur'}
                ],
                information: [
                    {required: true, message: '请输入预警描述', trigger: 'blur'}
                ],
                status: [
                    {required: true, message: '请选择处理状态', trigger: 'blur'}
                ],
                is_queren: [
                    {required: true, message: '请选择预警状态', trigger: 'blur'}
                ],
                cailiao: [
                    {required: true, message: '请上传文件', trigger: 'blur'}
                ],
            }
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        type: {
            type: Boolean,
            default: false
        },
        id: {
            type: [String, Number],
            default: ''
        },
    },
    computed:{
        readonly() {
            return !!this.id
        }
    },
    components: {UploadFile},
    created() {
        this.init()
    },
    methods: {
        async init() {
            let _data = await org_lst(
                '',
                '',
                '',
                '',
                '',
                '',
                 1,
                 10000
            )
            this.orgList = _data.data.data
        },
        async getWarningDetail(){
            let _data = await getWarningDetail(this.id)
            this.ruleForm.org_id = _data.data.org_id
            this.ruleForm.level = _data.data.level
            this.ruleForm.info = _data.data.info
            this.ruleForm.information = _data.data.instruction
            this.ruleForm.status = _data.data.status
            this.ruleForm.cailiao = _data.data.cailiao
            this.ruleForm.chengnuoshu = _data.data.chengnuoshu
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid, validates) => {
                if (valid) {
                    this.submitInfo()
                } else {
                    scrollIntoView(this, validates)
                }
            });
        },

        async submitInfo() {
            let _data = await addWarning(
                this.ruleForm.org_id,
                this.ruleForm.level,
                this.ruleForm.info,
                this.ruleForm.information,
                this.ruleForm.status,
                this.ruleForm.is_queren,
                this.ruleForm.cailiao
            );
            if (_data.status == 200) {
                this.$message.success(_data.msg);
                this.$emit('handleClose', true)
            } else {
                this.$message.error(_data.msg);
            }
        },
        handleClose() {
            this.$emit('handleClose', false)
        },
        uploadFile(data) {
            this.ruleForm[data.name] = data.file.url
        },
    },
    watch: {
        dialogVisible() {
            if (this.dialogVisible) {
                this.$refs.ruleForm?.resetFields()
                if (this.id){
                    this.getWarningDetail()
                }
            }
        }
    },
    filters: {}
}
</script>

<style lang="scss" scoped>
.title {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
}

.form-content {
    width: 100%;

    .title-flex {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-bottom: 20px;

        b {
            font-size: 18px;
            color: #000000;
            font-weight: bold;
            margin-right: 10px;
        }
    }


    .width {
        width: 400px;
    }

    .btn-box {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 30px 0;

        .btn {
            width: 180px;
            height: 40px;
            background-image: linear-gradient(0deg,
                #2791ff 0%,
                #81b6ff 100%);
            border-radius: 20px;
            text-align: center;
            line-height: 40px;
            font-size: 16px;
            letter-spacing: 1px;
            color: #ffffff;
            cursor: pointer;

            &.cancel {
                width: 180px;
                height: 40px;
                background: #f0f2f6;
                border-radius: 20px;
                border: solid 1px #c1c3c7;
                color: #9da0a7;
                margin-left: 20px;
            }
        }
    }

    .add {
        width: 24px;
        cursor: pointer;
    }


    .inp {
        width: 100%;
    }

    .tips {
        width: max-content;
        padding: 0 10px;
        height: 36px;
        background-color: #fef0ef;
        border-radius: 4px;
        margin-left: 10px;
        font-size: 14px;
        color: #f34336;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        line-height: 16px;

        i {
            font-size: 20px;
            color: #f34336;
            margin-right: 4px;
        }

        &.width {
            width: 160px;
        }
    }

    .look {
        width: max-content;
        padding: 0 10px;
        height: 36px;
        border: 1px solid #2791ff;
        color: #2791ff;
        line-height: 34px;
        text-align: center;
        font-size: 14px;
        margin-left: 10px;
        border-radius: 4px;

    }

    .mt15 {
        margin-top: 15px;
    }

    .btnUp {
        width: max-content;
        padding: 0 10px;
        height: 36px;
        margin-left: 10px;
        background-image: linear-gradient(90deg,
            #2791ff 0%,
            #81b6ff 100%);
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #ffffff;

        i {
            font-size: 20px;
            color: #ffffff;
            margin-right: 5px;
            font-weight: 100;
        }
    }
}

.title-box {
    width: 100%;
    height: 60px;
    border-bottom: solid 2px #e3e7f0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .tit-left {
        display: flex;
        justify-content: flex-start;
        padding-top: 25px;

        img {

        }

        b {
            font-size: 22px;
            color: #16181d;
            font-weight: bold;
            margin-left: 5px;
        }
    }
}
</style>


